module.exports = __webpack_public_path__ + "img/ground-ground-evening.424bc951.png";